import { COMPONENT_NAME } from '@core/components/grid-data/grid-helper';
import { ActivityLogType } from '@core/configs/activity-log-type.enum';

export const activityLogTsushoConfig = {
  width: '100%',
  height: '100%',
  min: 8,
  interval: 2,
  max: 15,
  timeInterval: 30,
  itemHeight: 'auto',
  rows: 2,
  borderColor: '#FFFFFF',
  isHiddenBorder: false,
  isHiddenHeader: true,
  segmentNum: 4,
  showOdd: true,
  type: ActivityLogType.LogMaxMin,
  marginToTime: 45
};

export const tsushoGridConfig = {
  isLockPage: false,
  currentPage: 1,
  pageSize: 10,
  totalPage: 1,
  intervalTime: 30000,
  data: [],
  header: [
    {
      width: "1.5vw",
      fixedSize: true,
      items: [{ title: '' }],
      field: 'index',
      component: COMPONENT_NAME.LeaveComponent,
      config: { isDarkMode: true, width: '100%', height: '100%', cellClass: "default" }
    },
    {
      width: "12vw",
      items: [{ title: '名前' }],
      field: 'user',
      headerName: '名前',
      fixedSize: true,
      component: COMPONENT_NAME.UserInfoComponent,
      config: { isDarkMode: true, cellClass: "scrolling-text" }
    },
    {
      width: "11%",
      items: [{ title: '連絡' }],
      field: 'notice_list',
      headerName: '連絡',
      component: COMPONENT_NAME.TextMarqueeComponent,
      config: { width: '100%', height: '100%', cellClass: "scrolling-text" }
    },
    {
      width: "9%",
      items: [{ title: '体温', textAlign: 'center', padding: '0 0 0 0.4vw' }, { title: '脈拍', textAlign: 'center', padding: '0 0.4vw 0 0' }],
      isSplitCell: true,
      subheader: [{
        width: "100%",
        items: [{ width: "50%", title: '血圧', textAlign: 'center', padding: '0 0 0 0.4vw' }, { width: "50%", title: 'SPO2', textAlign: 'center', padding: '0 0.4vw 0 0' }],
      }],
      field: 'vital',
      headerName: 'バイタル',
      component: COMPONENT_NAME.VitalComponent,
      config: { isDarkMode: true, cellClass: "scrolling-text" }
    },
    {
      width: "4%",
      items: [{ title: '入浴' }],
      field: 'bathe',
      headerName: '入浴',
      component: COMPONENT_NAME.AttentionComponent,
      config: { isDarkMode: true, cellClass: "dynamic-label", activeCancelMark: true }
    },
    {
      width: "4%",
      items: [{ title: '機能' }],
      field: 'training',
      headerName: '機能訓練',
      component: COMPONENT_NAME.AttentionComponent,
      config: { cellClass: "dynamic-label", activeCancelMark: true },
      subheader: [{
        width: "100%",
        items: [{ title: '訓練' }],
      }]
    },
    {
      width: "5%",
      items: [{ title: '食事' }],
      field: 'meal',
      headerName: '食事',
      component: COMPONENT_NAME.MealComponent,
      config: { isDarkMode: true, cellClass: "scrolling-text" }
    },
    {
      width: "5%",
      items: [{ title: 'おやつ' }],
      field: 'snack',
      headerName: 'おやつ',
      component: COMPONENT_NAME.BatsuMaruComponent,
      config: { isDarkMode: true, cellClass: "scrolling-text" }
    },
    {
      width: "4%",
      items: [{ title: '水分' }],
      subheader: [{
        width: "100%",
        items: [{ title: '合計' }],
      }],
      field: 'moisture',
      headerName: '水分合計',
      component: COMPONENT_NAME.DynamicLabelComponent,
      config: { isDarkMode: true, width: '100%', height: '100%', cellClass: "scrolling-text" }
    },
    {
      width: "4%",
      items: [{ title: '口腔' }],
      field: 'oral',
      headerName: '口腔',
      component: COMPONENT_NAME.YesNoIndicatorComponent,
      config: { isDarkMode: true, width: '100%', height: '100%' }
    },
    {
      width: "24%",
      items: [{ title: '服薬　排泄' }],
      headeRepeat: 1,
      subheader: [{
        width: "100%",
        items: [{ title: '服薬　排泄', useComponent: true, componentSubHeader: COMPONENT_NAME.FieldActivityHeaderComponent, configSubHeader: activityLogTsushoConfig }],
      }],
      field: 'excretion_list',
      headerName: '服薬　排泄',
      component: COMPONENT_NAME.FieldActivityLogComponent,
      config: activityLogTsushoConfig,
    },
    {
      width: "auto",
      items: [{ title: '申し送り' }],
      field: 'attention_list',
      headerName: '申し送り',
      component: COMPONENT_NAME.TextMarqueeComponent,
      config: { isDarkMode: true, width: '100%', height: '100%', highlight: true, cellClass: "scrolling-text" }
    },
  ]
};
